var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 25C3.40278 25 2.74907 24.7282 2.20555 24.1847C1.66204 23.6412 1.38981 22.987 1.38889 22.2222V4.16667H0V1.38889H6.94444V0H15.2778V1.38889H22.2222V4.16667H20.8333V22.2222C20.8333 22.9861 20.5616 23.6403 20.0181 24.1847C19.4745 24.7292 18.8204 25.0009 18.0556 25H4.16667ZM18.0556 4.16667H4.16667V22.2222H18.0556V4.16667ZM6.94444 19.4444H9.72222V6.94444H6.94444V19.4444ZM12.5 19.4444H15.2778V6.94444H12.5V19.4444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6ba065832db4ed47ebed953480e06289.svg";
export { ForwardRef as ReactComponent };